import { useMemo, useState } from "react";
import { Input } from "../ui/input";
import { Search } from "lucide-react";

const SETTINGS_INDEX = [
  { label: "Display Name", tab: "profile", sectionId: "settings-section-name", keywords: ["name", "display name", "username"] },
  { label: "Avatar, Banner & Bio", tab: "profile", sectionId: "settings-section-avatar", keywords: ["avatar", "picture", "photo", "banner", "bio", "about"] },
  { label: "Public Knights Fee Profile", tab: "profile", sectionId: "settings-section-public-profile", keywords: ["public profile", "knights fee", "view profile"] },
  { label: "Change Password", tab: "account", sectionId: "settings-section-password", keywords: ["password", "change password", "login"] },
  { label: "Two-Factor Login", tab: "account", sectionId: "settings-section-2fa", keywords: ["two factor", "2fa", "authenticator", "security", "totp"] },
  { label: "Adult Content Visibility", tab: "bazaar", sectionId: "settings-section-adult", keywords: ["adult", "mature", "nsfw", "content"] },
  { label: "Merchant Status", tab: "bazaar", sectionId: "settings-section-merchant", keywords: ["merchant", "seller", "become a merchant", "bazaar"] },
  { label: "Subscription / GM Plan", tab: "subscription", sectionId: "settings-section-billing", keywords: ["subscription", "billing", "plan", "stripe", "gm plan", "payment", "raid pass"] },
];

// Jumps straight to any setting by keyword, instead of making a Knight hunt across 4 tabs.
export function SettingsSearch({ onJump }) {
  const [query, setQuery] = useState("");

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return [];
    return SETTINGS_INDEX.filter((entry) => entry.label.toLowerCase().includes(q) || entry.keywords.some((k) => k.includes(q))).slice(0, 6);
  }, [query]);

  const jump = (entry) => {
    setQuery("");
    onJump(entry.tab, entry.sectionId);
  };

  return (
    <div className="relative" data-testid="settings-search">
      <div className="relative">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-[#f1e0c5]/40" />
        <Input
          data-testid="settings-search-input"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search settings… (e.g. password, adult content, subscription)"
          className="pl-10 bg-black/30 border-white/10"
        />
      </div>
      {results.length > 0 && (
        <div data-testid="settings-search-results" className="absolute z-20 mt-1.5 w-full rounded-lg border border-white/10 bg-[#1c140c] shadow-xl overflow-hidden">
          {results.map((entry, i) => (
            <button
              key={entry.sectionId}
              data-testid={`settings-search-result-${i}`}
              onClick={() => jump(entry)}
              className="w-full text-left px-4 py-2.5 text-sm hover:bg-white/5 flex items-center justify-between gap-2"
            >
              {entry.label}
              <span className="text-[10px] uppercase tracking-wider text-[#f1e0c5]/30">{entry.tab}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
